import React from 'react';
import CustomModal from './index';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const ModalDialog = ({
  buttonLeftTitle,
  buttonRightTitle,
  title,
  action,
  icon = true,
  close,
  children,
}) => {
  const buttons = [
    {
      title: buttonLeftTitle,
      className: 'btn btn-danger text-center w-25',
      action: () => {
        action();
        close();
      },
    },
    {
      title: buttonRightTitle,
      className: 'btn btn-secondary text-center w-25',
      action: close,
    },
  ];

  return (
    <CustomModal
      title={title}
      show={true}
      close={close}
      buttons={buttons}
      justifyContentButtons='center'
    >
      {icon && (
        <div className='d-flex justify-content-center pt-3 my-3'>
          <FontAwesomeIcon
            icon={faQuestionCircle}
            className='text-warning'
            style={{ transform: 'scale(2)' }}
          />
        </div>
      )}
      <div className='d-flex justify-content-center p-4 text-center'>{children}</div>
    </CustomModal>
  );
};

ModalDialog.proptypes = {
  title: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default ModalDialog;
